import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const Method = () => {
  return (
    <section
      id="metodo"
      className="bg-[#FDFBF7] py-20 md:py-32"
      data-testid="method-section"
    >
      <div className="mx-auto max-w-4xl px-6 text-center md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            Método
          </p>
          <h2
            className="font-serif text-3xl leading-tight text-[#3E2723] sm:text-4xl lg:text-5xl gold-line-center"
            data-testid="method-title"
          >
            O que torna meu <em className="italic">método diferente</em>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="mt-12 space-y-6 text-left md:text-center"
        >
          <p className="font-serif text-2xl italic text-[#8B6F1F] md:text-3xl">
            Não existe fórmula pronta.
          </p>
          <p className="text-base leading-relaxed text-[#4E342E]/85 md:text-lg">
            Meu trabalho é entender profundamente sua história, seus hábitos,
            seus exames e seus objetivos. A consulta não é focada apenas na
            balança — ela busca compreender o que está acontecendo com seu
            organismo para construir um plano sustentável e compatível com sua
            rotina.
          </p>

          <div className="mx-auto mt-12 max-w-2xl rounded-3xl border border-[#D4AF37]/20 bg-[#F5EFE6]/60 p-8 md:p-12">
            <Quote
              className="mx-auto mb-4 h-8 w-8 text-[#D4AF37]"
              strokeWidth={1.5}
            />
            <p className="font-serif text-xl italic text-[#3E2723] md:text-2xl">
              Saúde de verdade não é feita de soluções rápidas. É construída com
              estratégia, acompanhamento e constância.
            </p>
          </div>

          <div className="relative mx-auto mt-14 max-w-3xl">
            <div className="absolute -inset-3 rounded-[2.5rem] border border-[#D4AF37]/25" />
            <img
              src="https://customer-assets-eiarnc6j.emergentagent.net/job_metodo-mariana/artifacts/xpbmo66q_IMG_0554.JPG"
              alt="Dra. Mariana Alves sorrindo"
              className="relative h-[420px] w-full rounded-[2rem] object-cover object-top"
              data-testid="method-image"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Method;
